import React,{createContext,useEffect,useState} from 'react';

import UpdatedNavbar from '../components/updatedNavbar';
import UpdatedFooter from '../components/updatedFooter';
import CuratedProgram from '../components/CuratorProgram';

export const UriContext = createContext();

const CuratedProgramPage = ({uri}) => {

  useEffect(()=>{
    if(!uri){
      uri = localStorage.getItem('url');
    }
  },[]);

  return (
    <div
      style={{ backgroundColor: '#000000',width:'100vw'}}
    > 
      <div style={{ backgroundColor: '#181819',maxWidth:'600px',width:'100vw',position:'relative',left:'50vw',top:0,transform:'translateX(-50%)'}}>
        
        <UriContext.Provider value={uri }> 
            <UpdatedNavbar />    
            
            <CuratedProgram />
            
            <UpdatedFooter/>
        </UriContext.Provider>
      </div>

    </div>
  )
}

export default CuratedProgramPage